enum View {
  Start,
  Login,
  ProfiControlUser,
  Operator,
  Customer,
  CustomerCoreData,
  CustomerPointOfSalesManagement,
  Issuer,
  IssuerUserManagement,
  CardUsers,
  CardUserCoreData,
  Report,
  PasswordResetOverview,
  ChangePassword,
  AdministerCards,
  IssuerCoreData,
  AdministerIssuerCards,
  AdministerIssuerWebcharges,
  IssuerReports,
  CustomerBankTransfers,
  IssuerBankTransfers,
  AdminImports,
  GeneralSettings,
  IssuerSettings,
  DeviceManagement,
  CustomerDeviceManagement,
  CustomerApiKeyManagement,
  CustomerAuthCardManagement,
  CustomerReports,
  AccountGroupManagement,
  MerchantTransactionManagement,
  DailyTotalsManagement,
  TransactionManagement,
  AccountManagement,
  IssuerTransactionManagement,
  SchedulerJobs
}

// TODO: Rename it later to PascalCase when old role system is out of order.
enum Roles {
  None = 'None',
  Administrator = 'Administrator',
  Hauptbenutzer = 'Hauptbenutzer',
  Benutzer = 'Benutzer',
  BenutzerFinanz = 'BenutzerFinanz',
}

enum VatType {
  Regular = 'Regular',
  Reduced = 'Reduced'
}

enum CustomerState {
  Interested = 'Interested',
  Confirmed = 'Confirmed', // Abrechnung aktiv
  Contracted = 'Contracted', // Vertrag geschlossen
  Canceled = 'Canceled' // Vertrag beendet
}

enum IssuerStatus {
  Interested = 'Interested',
  Confirmed = 'Confirmed', // Abrechnung aktiv
  Contracted = 'Contracted', // Vertrag geschlossen
  Canceled = 'Canceled' // Vertrag beendet
}

enum WebChargeInterval {
  Once = 'Once',
  Unknown = 'Unknown',
  Monthly = 'Monthly'
}

enum SepaType {
  all = 'All',
  //Sepa credit (Gutschrift) standard specification do not touch
  pain_001_003_03 = 'Credit',
  //Sepa direct debit (Lastschrift) standard specification do not touch
  pain_008_003_02 = 'Debit',
}

enum ProfiControlUserError {
  None = 'None',
  DuplicateUserName = 'DuplicateUserName',
  Unknown = 'Unknown'
}

enum TopUpRotation {
  None = 'None',
  Once = 'Once',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
  Gratification = 'Gratification',
}

enum WebChargeStatus {
  Unknown = 'Unknown',
  Success = 'Success',
  SystemError = 'SystemError',
  MaxAccountLimitViolated = 'MaxAccountLimitViolated',
  MaxMonthlyTopUpViolated = 'MaxMonthlyTopUpViolated',
  MinAccountLimitViolated = 'MinAccountLimitViolated',
  TimeConstraintViolated = 'TimeConstraintViolated',
  ValidationError = 'ValidationError',
  AccountBlocked = 'AccountBlocked',
  AccountClosed = 'AccountClosed',
  AccountInUse = 'AccountInUse',
  AccountNotFound = 'AccountNotFound'
}

enum ResponseState {
  unknown = 'Unknown',
  success = 'Success',
  error = 'Error'
}

enum TransactionType {
  all = 'All',
  terminal = 'Terminal',
  other = 'Other',
  charges = 'Charges',
  customerCharges = 'CustomerCharges',
}

enum CardStates {
  Unassigned = 'Unassigned',
  Assigned = 'Assigned'
}

enum ErrorCodes {

  // codes used by the client application

  client_request_aborted = 'CLIENT_ABORT',
  client_request_timeout = 'CLIENT_TIMEOUT',
  client_network_error = 'CLIENT_NETWORK_ERROR',
  client_session_expired = 'CLIENT_SESSION_EXPIRED',

  // codes returned by the server

  unknown = 'ERR_UNKNOWN',
  duplicate_username = 'ERR_DUPLICATE_USERNAME',
  not_found = 'ERR_MISSING_RECORD',
  err_reset_not_possible = 'ERR_RESET_NOT_POSSIBLE',
  duplicate_record = 'ERR_DUPLICATE_RECORD',
  idetity_user_already_assigned = 'ERR_IDENTITY_USER_ALREADY_ASSIGNED',
  validation_error = 'ERR_VALIDATION_ERROR',
  account_has_non_zero_balance = 'ERR_ACCOUNT_HAS_NON_ZERO_BALANCE',
}

enum AccountingPeriod {
  daily = 'Daily',
  weekly = 'Weekly',
  biweekly = 'Biweekly',
  monthly = 'Monthly'
}

enum PaymentMethod {
  invoice = 'Invoice',
  baseDebit = 'BasicDebit',
  companyDebit = 'CompanyDebit'
}

enum DebitType {
  all = 'All',
  basic = 'Basic',
  company = 'Company'
}

enum PersonalizationType {
  Unknown = 0,
  Text = 'Text',
  LogoPart = 'LogoPart',
  LogoFull = 'LogoFull'
}


export {
  ResponseState,
  WebChargeStatus,
  TopUpRotation,
  ProfiControlUserError,
  SepaType,
  WebChargeInterval,
  IssuerStatus,
  VatType,
  CustomerState,
  Roles,
  View,
  TransactionType,
  CardStates,
  ErrorCodes,
  AccountingPeriod,
  PaymentMethod,
  DebitType,
  PersonalizationType,
}
